import React from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { EPremiumDueTabs } from './types';

interface PremiumDueTabsProps {
  activeTab: string;
  setActiveTab: (key: EPremiumDueTabs) => void;
}

const PremiumDueTabs: React.FC<PremiumDueTabsProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const { t } = useTranslation();

  const premiumDueTabs = [
    {
      key: EPremiumDueTabs.Unpaid,
      label: (
        <span className="flex gap-2 items-center">
          {t('dashboard.premiumDueTabs.unpaid')}
        </span>
      ),
    },
    {
      key: EPremiumDueTabs.Paid,
      label: (
        <span className="flex gap-2 items-center">
          {t('dashboard.premiumDueTabs.paid')}
        </span>
      ),
    },
  ];

  return (
    <div className="bg-[#E3F2FB] rounded-xl w-fit mb-3">
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key as EPremiumDueTabs)}
        items={premiumDueTabs}
        className="custom-tabs uw-custom-tabs ant-tabs-tab"
        tabBarGutter={8}
        tabBarStyle={{ margin: 0 }}
      />
    </div>
  );
};

export default PremiumDueTabs;
